import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "commission_container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "textRow" }
const _hoisted_4 = { class: "dateRow" }

import { onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getRewardList } from '@/api/agent';
import { formatCurrency } from '@/utils/commonFunction';
import { getNextPageRewardDataFunc, getRewardDataFunc, RewardData } from '@/view/agent/supportScript';
import NoData from '../../components/common/noData.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'commissionView',
  setup(__props) {

const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const total = ref(0)
const pageSize = ref(20)
const pageNumber = ref(1)
const rewardData = ref<RewardData[]>([])
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getNextPageRewardData = () => {
    getNextPageRewardDataFunc(total,pageSize,getRewardData,loadingRef)
}
const getRewardData = () => {
      getRewardDataFunc(getRewardList, pageNumber, rewardData, total, loadingRef, showError)
}

onMounted(() => {
    loadingRef.value.open()
    getRewardData()
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    (rewardData.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rewardData.value, (i, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "dataCard",
              key: index
            }, [
              _createVNode(_component_van_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, { span: "12" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(i.type == 1 ? _ctx.$t('commission.recharge') : _ctx.$t('commission.betting')), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(i.createTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "valueText"
                  }, {
                    default: _withCtx(() => [
                      _cache[0] || (_cache[0] = _createElementVNode("span", null, "R$ ", -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(i.coin)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128)),
          (total.value > pageSize.value)
            ? (_openBlock(), _createBlock(_component_van_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "24",
                    class: "arrowDown"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "",
                        onClick: getNextPageRewardData
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(NoData, { key: 1 }))
  ]))
}
}

})